









// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   collection,
//   query,
//   where,
//   orderBy,
//   onSnapshot,
// } from "firebase/firestore";
// import { auth, db } from "../firebase";
// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";
// import "./logs.css";

// // ------------------------------------------------------------
// // 1. HELPER FUNCTIONS (unchanged)
// // ------------------------------------------------------------
// const getStatusFromEvents = (events) => {
//   const relevant = events.filter((e) =>
//     ["ACKNOWLEDGED", "DISPUTED", "NO_RESPONSE"].includes(e.event_type)
//   );
//   if (relevant.length === 0) return "Pending";
//   relevant.sort((a, b) => {
//     const aTime = a.created_at?.toDate?.() || 0;
//     const bTime = b.created_at?.toDate?.() || 0;
//     return bTime - aTime;
//   });
//   const latest = relevant[0];
//   switch (latest.event_type) {
//     case "ACKNOWLEDGED":
//       return "Agreed";
//     case "DISPUTED":
//       return "Disputed";
//     case "NO_RESPONSE":
//       return "No response";
//     default:
//       return "Pending";
//   }
// };

// // ------------------------------------------------------------
// // 2. STATISTICS CALCULATION (from logs + all events)
// // ------------------------------------------------------------
// const calculateStats = (logs, allEvents) => {
//   const eventsByLog = {};
//   allEvents.forEach((e) => {
//     if (e.log_id) {
//       if (!eventsByLog[e.log_id]) eventsByLog[e.log_id] = [];
//       eventsByLog[e.log_id].push(e);
//     }
//   });

//   let totalLogs = logs.length;
//   let statusCounts = {
//     Pending: 0,
//     Agreed: 0,
//     Disputed: 0,
//     "No response": 0,
//   };
//   let typeCounts = { Email: 0, Manual: 0 };
//   let totalEvents = allEvents.length;

//   // Last 7 days (for trends)
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);
//   const last7Days = Array.from({ length: 7 }, (_, i) => {
//     const d = new Date(today);
//     d.setDate(d.getDate() - (6 - i));
//     return d;
//   });

//   const logsPerDay = {};
//   const eventsPerDay = {};
//   last7Days.forEach((d) => {
//     const key = d.toISOString().split("T")[0];
//     logsPerDay[key] = 0;
//     eventsPerDay[key] = 0;
//   });

//   logs.forEach((log) => {
//     const logEvents = eventsByLog[log.id] || [];
//     const status = getStatusFromEvents(logEvents);
//     statusCounts[status] = (statusCounts[status] || 0) + 1;

//     const type = log.log_type || "Manual";
//     if (typeCounts[type] !== undefined) typeCounts[type]++;
//     else typeCounts[type] = 1;

//     if (log.created_at) {
//       const date = log.created_at.toDate();
//       const key = date.toISOString().split("T")[0];
//       if (logsPerDay[key] !== undefined) logsPerDay[key]++;
//     }
//   });

//   allEvents.forEach((e) => {
//     if (e.created_at) {
//       const date = e.created_at.toDate();
//       const key = date.toISOString().split("T")[0];
//       if (eventsPerDay[key] !== undefined) eventsPerDay[key]++;
//     }
//   });

//   const dailyLogsData = last7Days.map((d) => ({
//     name: `${d.getMonth() + 1}/${d.getDate()}`,
//     value: logsPerDay[d.toISOString().split("T")[0]] || 0,
//   }));

//   const dailyEventsData = last7Days.map((d) => ({
//     name: `${d.getMonth() + 1}/${d.getDate()}`,
//     value: eventsPerDay[d.toISOString().split("T")[0]] || 0,
//   }));

//   return {
//     totalLogs,
//     statusCounts,
//     typeCounts,
//     totalEvents,
//     dailyLogsData,
//     dailyEventsData,
//   };
// };

// // ------------------------------------------------------------
// // 3. SMALL, ATTRACTIVE DASHBOARD CARD (compact charts)
// // ------------------------------------------------------------
// const DashboardCard = ({
//   title,
//   metric,
//   percentageChange,
//   chartType,
//   chartData,
//   accentColor = "#FFA500",
// }) => {
//   const isPositive = percentageChange >= 0;
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => setIsVisible(true), 50);
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <div className={`dashboard-card ${isVisible ? "fade-in" : ""}`}>
//       <div className="card-header">
//         <h3 className="card-title">{title}</h3>
//       </div>
//       <div className="metric">{metric}</div>
//       <div className="growth-row">
//         <span className={`growth-icon ${isPositive ? "positive" : "negative"}`}>
//           {isPositive ? "▲" : "▼"}
//         </span>
//         <span className={`growth-value ${isPositive ? "positive" : "negative"}`}>
//           {Math.abs(percentageChange).toFixed(1)}%
//         </span>
//         <span className="growth-label">vs last month</span>
//       </div>
//       <div className="chart-container">
//         <ResponsiveContainer width="100%" height={60}>
//           {chartType === "line" ? (
//             <LineChart data={chartData}>
//               <CartesianGrid horizontal={false} vertical={false} />
//               <XAxis dataKey="name" hide />
//               <YAxis hide domain={[0, "auto"]} />
//               <Tooltip
//                 contentStyle={{
//                   backgroundColor: "white",
//                   borderRadius: 8,
//                   border: "none",
//                   boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                   fontSize: 12,
//                   padding: "4px 8px",
//                 }}
//               />
//               <Line
//                 type="monotone"
//                 dataKey="value"
//                 stroke={accentColor}
//                 strokeWidth={2}
//                 dot={false}
//                 activeDot={{ r: 3 }}
//               />
//             </LineChart>
//           ) : (
//             <BarChart data={chartData}>
//               <CartesianGrid horizontal={false} vertical={false} />
//               <XAxis dataKey="name" hide />
//               <YAxis hide />
//               <Tooltip
//                 contentStyle={{
//                   backgroundColor: "white",
//                   borderRadius: 8,
//                   border: "none",
//                   boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                   fontSize: 12,
//                   padding: "4px 8px",
//                 }}
//               />
//               <Bar dataKey="value" fill={accentColor} radius={[4, 4, 0, 0]} barSize={12} />
//             </BarChart>
//           )}
//         </ResponsiveContainer>
//       </div>
//     </div>
//   );
// };

// // ------------------------------------------------------------
// // 4. MAIN DASHBOARD (cards + logs list)
// // ------------------------------------------------------------
// export default function Dashboard1() {
//   const [logs, setLogs] = useState([]);
//   const [events, setEvents] = useState([]);      // all events
//   const [finalEvents, setFinalEvents] = useState({}); // for status
//   const [search, setSearch] = useState("");
//   const [filter, setFilter] = useState("All");
//   const [loading, setLoading] = useState(true);
//   const [stats, setStats] = useState(null);

//   const navigate = useNavigate();

//   // ---------- Firebase listeners ----------
//   useEffect(() => {
//     if (!auth.currentUser) return;

//     // Logs listener
//     const logsQuery = query(
//       collection(db, "logs"),
//       where("owner_id", "==", auth.currentUser.uid),
//       orderBy("created_at", "desc")
//     );
//     const unsubLogs = onSnapshot(logsQuery, (snap) => {
//       const list = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setLogs(list);
//     });

//     // All events listener (requires composite index on owner_id + created_at)
//     const eventsQuery = query(
//       collection(db, "log_events"),
//       where("owner_id", "==", auth.currentUser.uid),
//       orderBy("created_at", "desc")
//     );
//     const unsubEvents = onSnapshot(eventsQuery, (snap) => {
//       const list = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setEvents(list);

//       // Build finalEvents map for status (only ACKNOWLEDGED, DISPUTED, NO_RESPONSE)
//       const map = {};
//       list.forEach((ev) => {
//         if (["ACKNOWLEDGED", "DISPUTED", "NO_RESPONSE"].includes(ev.event_type)) {
//           map[ev.log_id] = ev.event_type;
//         }
//       });
//       setFinalEvents(map);
//       setLoading(false);
//     }, (error) => {
//       console.error("Snapshot error:", error);
//       setLoading(false);
//     });

//     return () => {
//       unsubLogs();
//       unsubEvents();
//     };
//   }, []);

//   // ---------- Recalculate stats when logs/events change ----------
//   useEffect(() => {
//     if (!loading) {
//       const calculated = calculateStats(logs, events);
//       setStats(calculated);
//     }
//   }, [logs, events, loading]);

//   // ---------- Status getter (from finalEvents) ----------
//   const getStatus = (logId) => {
//     const ev = finalEvents[logId];
//     if (ev === "ACKNOWLEDGED") return "Agreed";
//     if (ev === "DISPUTED") return "Disputed";
//     if (ev === "NO_RESPONSE") return "No response";
//     return "Pending";
//   };

//   // ---------- Filter logs ----------
//   const filteredLogs = logs.filter((log) => {
//     const title = log.title?.toLowerCase() || "";
//     const status = getStatus(log.id);
//     const matchesSearch = title.includes(search.toLowerCase());
//     const matchesFilter =
//       filter === "All" ||
//       status === filter ||
//       log.log_type === filter.toUpperCase();
//     return matchesSearch && matchesFilter;
//   });

//   // ---------- Mock trend helper (for status cards) ----------
//   const generateMockTrend = (days, min, max) => {
//     return Array.from({ length: days }, (_, i) => ({
//       name: i.toString(),
//       value: Math.floor(Math.random() * (max - min + 1) + min),
//     }));
//   };

//   // ---------- Build card data from stats ----------
//   const getCards = () => {
//     if (!stats) return [];

//     const {
//       totalLogs,
//       statusCounts,
//       typeCounts,
//       totalEvents,
//       dailyLogsData,
//       dailyEventsData,
//     } = stats;

//     return [
//       {
//         title: "Total Logs",
//         metric: totalLogs.toString(),
//         percentageChange: 12.3,
//         chartType: "line",
//         chartData: dailyLogsData,
//         accentColor: "#FFA500",
//       },
//       {
//         title: "Pending",
//         metric: (statusCounts.Pending || 0).toString(),
//         percentageChange: -2.1,
//         chartType: "line",
//         chartData: generateMockTrend(7, 5, 15),
//         accentColor: "#FFB300",
//       },
//       {
//         title: "Agreed",
//         metric: (statusCounts.Agreed || 0).toString(),
//         percentageChange: 8.4,
//         chartType: "line",
//         chartData: generateMockTrend(7, 10, 20),
//         accentColor: "#4CAF50",
//       },
//       {
//         title: "Disputed",
//         metric: (statusCounts.Disputed || 0).toString(),
//         percentageChange: -5.7,
//         chartType: "line",
//         chartData: generateMockTrend(7, 2, 8),
//         accentColor: "#F44336",
//       },
//       {
//         title: "No Response",
//         metric: (statusCounts["No response"] || 0).toString(),
//         percentageChange: 3.2,
//         chartType: "line",
//         chartData: generateMockTrend(7, 4, 12),
//         accentColor: "#9E9E9E",
//       },
//       {
//         title: "Email Logs",
//         metric: (typeCounts.Email || 0).toString(),
//         percentageChange: 6.5,
//         chartType: "bar",
//         chartData: [
//           { name: "Email", value: typeCounts.Email || 0 },
//           { name: "Manual", value: typeCounts.Manual || 0 },
//         ],
//         accentColor: "#2196F3",
//       },
//       {
//         title: "Manual Logs",
//         metric: (typeCounts.Manual || 0).toString(),
//         percentageChange: -1.3,
//         chartType: "line",
//         chartData: generateMockTrend(7, 8, 18),
//         accentColor: "#009688",
//       },
//       {
//         title: "Total Events",
//         metric: totalEvents.toString(),
//         percentageChange: 14.2,
//         chartType: "line",
//         chartData: dailyEventsData,
//         accentColor: "#9C27B0",
//       },
//       {
//         title: "Response Rate",
//         metric: `${(
//           ((statusCounts.Agreed || 0) + (statusCounts.Disputed || 0)) /
//           totalLogs *
//           100
//         ).toFixed(1)}%`,
//         percentageChange: 4.0,
//         chartType: "bar",
//         chartData: [
//           {
//             name: "Responded",
//             value: (statusCounts.Agreed || 0) + (statusCounts.Disputed || 0),
//           },
//           {
//             name: "Pending/NoResp",
//             value: (statusCounts.Pending || 0) + (statusCounts["No response"] || 0),
//           },
//         ],
//         accentColor: "#3F51B5",
//       },
//       {
//         title: "Events per Log",
//         metric: (totalEvents / totalLogs).toFixed(1),
//         percentageChange: 2.3,
//         chartType: "bar",
//         chartData: [
//           { name: "Avg", value: totalEvents / totalLogs },
//           { name: "Prev", value: (totalEvents / totalLogs) * 0.8 },
//         ],
//         accentColor: "#FF9800",
//       },
//     ];
//   };

//   const cards = getCards();
//   const goToCreateLog = () => navigate("/logs");
//   const openLog = (id) => navigate(`/logs/${id}`);

//   if (loading) {
//     return (
//       <div className="dashboard-loading">
//         <div className="spinner"></div>
//         <p>Loading your dashboard…</p>
//       </div>
//     );
//   }

//   return (
//     <div className="content-area">
//       <div className="content-card">
//         {/* HEADER */}
//         <div className="dashboard-header">
//           <h1>My Logs</h1>
//           <button onClick={goToCreateLog} className="create-btn">
//             + Create Log
//           </button>
//         </div>

//         {/* CARDS GRID – LANDSCAPE LAYOUT, SMALL & ATTRACTIVE */}
//         {stats && (
//           <div className="cards-grid">
//             {cards.map((card, index) => (
//               <DashboardCard key={index} {...card} />
//             ))}
//           </div>
//         )}

//         {/* SEARCH */}
//         <input
//           className="search-input"
//           placeholder="Search logs..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />

//         {/* FILTERS */}
//         <div className="filters">
//           {[
//             "All",
//             "Pending",
//             "Agreed",
//             "Disputed",
//             "No response",
//             "Email",
//             "Manual",
//           ].map((f) => (
//             <button
//               key={f}
//               className={filter === f ? "filter active" : "filter"}
//               onClick={() => setFilter(f)}
//             >
//               {f}
//             </button>
//           ))}
//         </div>

//         {/* LOG LIST */}
//         <div className="logs-list">
//           {filteredLogs.length === 0 ? (
//             <p className="empty-text">
//               No logs yet. Create your first log or capture emails via BCC.
//             </p>
//           ) : (
//             filteredLogs.map((log) => {
//               const status = getStatus(log.id);
//               return (
//                 <div
//                   key={log.id}
//                   className="log-item"
//                   onClick={() => openLog(log.id)}
//                 >
//                   <div>
//                     <h3>{log.title || "Untitled Log"}</h3>
//                     <span className="date">
//                       {log.created_at?.toDate
//                         ? log.created_at.toDate().toLocaleString()
//                         : ""}
//                     </span>
//                   </div>
//                   <span className={`status ${status.replace(/\s+/g, "")}`}>
//                     {status}
//                   </span>
//                 </div>
//               );
//             })
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }



import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { auth, db } from "../firebase";
import "./Dashboard.css"; // still needed for status badges, filters, etc.

export default function Dashboard() {
  const [logs, setLogs] = useState([]);
  const [finalEvents, setFinalEvents] = useState({});
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // --- Firebase listeners (unchanged) ---
  useEffect(() => {
    if (!auth.currentUser) return;
    const q = query(
      collection(db, "logs"),
      where("owner_id", "==", auth.currentUser.uid),
      orderBy("created_at", "desc")
    );
    const unsub = onSnapshot(q, (snap) => {
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setLogs(list);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!auth.currentUser) return;
    const q = query(
      collection(db, "log_events"),
      where("event_type", "in", ["ACKNOWLEDGED", "DISPUTED", "NO_RESPONSE"])
    );
    const unsub = onSnapshot(q, (snap) => {
      const map = {};
      snap.docs.forEach((d) => {
        const ev = d.data();
        map[ev.log_id] = ev.event_type;
      });
      setFinalEvents(map);
    });
    return () => unsub();
  }, []);

  const getStatus = (logId) => {
    const ev = finalEvents[logId];
    if (ev === "ACKNOWLEDGED") return "Agreed";
    if (ev === "DISPUTED") return "Disputed";
    if (ev === "NO_RESPONSE") return "No response";
    return "Pending";
  };

  // --- Filtering ---
  const filteredLogs = logs.filter((log) => {
    const title = log.title?.toLowerCase() || "";
    const status = getStatus(log.id);
    const matchesSearch = title.includes(search.toLowerCase());
    const matchesFilter =
      filter === "All" ||
      status === filter ||
      log.log_type === filter.toUpperCase();
    return matchesSearch && matchesFilter;
  });

  // --- Navigation ---
  const goToCreateLog = () => navigate("/logs");
  const openLog = (id) => navigate(`/logs/${id}`);

  return (
    <div className="content-area">
      <div className="content-card">
        {/* HEADER */}
        <div className="dashboard-header">
          <h1>My Logs</h1>
          <button onClick={goToCreateLog} className="create-btn">
            + Create Log
          </button>
        </div>

        {/* SEARCH */}
        <input
          className="search-input"
          placeholder="Search logs..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* FILTERS */}
        <div className="filters">
          {[
            "All",
            "Pending",
            "Agreed",
            "Disputed",
            "No response",
            "Email",
            "Manual",
          ].map((f) => (
            <button
              key={f}
              className={filter === f ? "filter active" : "filter"}
              onClick={() => setFilter(f)}
            >
              {f}
            </button>
          ))}
        </div>

        {/* LOG LIST */}
        <div className="logs-list">
          {loading ? (
            <p className="empty-text">Loading logs…</p>
          ) : filteredLogs.length === 0 ? (
            <p className="empty-text">
              No logs yet. Create your first log or capture emails via BCC.
            </p>
          ) : (
            filteredLogs.map((log) => {
              const status = getStatus(log.id);
              return (
                <div
                  key={log.id}
                  className="log-item"
                  onClick={() => openLog(log.id)}
                >
                  <div>
                    <h3>{log.title || "Untitled Log"}</h3>
                    <span className="date">
                      {log.created_at?.toDate
                        ? log.created_at.toDate().toLocaleString()
                        : ""}
                    </span>
                  </div>
                  <span className={`status ${status.replace(/\s+/g, "")}`}>
                    {status}
                  </span>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}















